import styled from "styled-components";

export const HeaderContainer = styled.div<{ isMobile: boolean }>`
  padding: var(--fd-space-space-4);
  background: var(--fd-colors-background-surface);
  border-radius: var(--fd-radii-border-radius-020)
    var(--fd-radii-border-radius-020) 0 0;
  border-radius: ${({ isMobile }) =>
    isMobile
      ? "0"
      : "var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020) 0 0"};
`;

export const Section = styled.div`
  background: var(--fd-colors-background-base);
`;
